import { JsonObject, JsonProperty } from 'json2typescript';

import { PBCDocumentInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCDocument')
export class PBCDocument implements PBCDocumentInterface {
    @JsonProperty('numero', StringAdapter)
    private _number: string = undefined;

    @JsonProperty('tipo', StringAdapter)
    private _type: string = undefined;

    @JsonProperty('codigoPais', StringAdapter, true)
    private _countryCode?: string = undefined;

    @JsonProperty('pais', StringAdapter, true)
    private _country?: string = undefined;

    @JsonProperty('comentario', StringAdapter, true)
    private _comment?: string = undefined;

    get number(): string {
        return this._number;
    }

    get type(): string {
        return this._type;
    }

    get countryCode(): string {
        return this._countryCode;
    }

    get country(): string {
        return this._country;
    }

    get comment(): string {
        return this._comment;
    }
}
